import BackgroundImage from "../../assets/images/login_bg.jpg"

const styles = theme => ({
  login: {
    display: "flex",
  },
  mainArea: {
    position: "relative",
    "@media (max-width: 1080px)": {
      width: "80%",
      height: "80%",
    },
    "@media (max-width: 958px)": {
      width: "100%",
      height: "100%",
    },
    // "@media (max-width: 568px)": {
    //   width: "80%",
    //   height: "80%",
    // },
  },
  logoArea: {
    display: "flex",
    "@media (max-width: 599px)": {
      display: "none",
    },
  },
  spacer: {
    flexBasis: "auto",
    flexGrow: "0",
    flexShrink: "0",
  },
  logoWrapper: {
    textAlign: "left",
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  tagline: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 28,
  },
  secondLine: {
    color: "#fff",
  },
  logo: {
    maxWidth: 110,
    width: "80%",
    marginBottom: 40,
  },
  cardRoot: {
    zIndex: 2,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: 1920,
    maxWidth: 386,
    transition: theme.transitions.create("max-width", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.complex,
    }),
    "@media (max-width: 1080px)": {
      width: "100%",
    },
    "@media (max-width: 958px)": {},
    "@media (max-width: 568px)": {},
  },
  isRegister: {
    maxWidth: 680,
    "@media (max-width: 756px)": {
      maxWidth: "100%",
    },
  },
  cardContentRoot: {
    paddingTop: 0,
  },
  actionsRoot: {
    justifyContent: "center",
    paddingBottom: 0,
  },
  copyRight: {
    position: "relative",
    marginTop: theme.spacing(3),
  },
  copyRightText: {
    color: theme.palette.primary.dark,
    bottom: 0,
    fontSize: 11,
    position: "absolute",
    right: 0,
    textAlign: "center",
    width: "100%",
    paddingBottom: theme.spacing(2),
  },
  forgotLoginButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
  },
  forgotLoginButton: {
    fontSize: 11,
    opacity: 0.7,
  },
  formLogoArea: {
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  formLogo: {
    maxWidth: 129,
  },
  titleImage: {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover",
    paddingTop: "40%",
    width: "100%",
    marginTop: theme.spacing(3),
    "@media (min-width: 600px)": {
      display: "none",
    },
  },
  formGroup: {
    flexGrow: 1,
    position: "relative",
  },
  form: {
    paddingBottom: theme.spacing(2),
    position: "absolute",
    top: "50%",
    width: "100%",
    "@media (max-width: 599px)": {
      transform: ["translate(0,0)", "!important"],
      top: 0,
    },
  },
  pinInputWrapper: {
    display: "flex",
    justifyContent: "space-around",
    padding: `0 ${theme.spacing(2)}px`,
  },
  pinInput: {
    margin: `0 ${theme.spacing(2)}px`,
  },
  pinInputInput: {
    textAlign: "center",
  },
  loginForm: {
    height: 248,
  },
  registerForm: {
    height: 390,
    "@media (max-width: 599px)": {
      height: 470,
    },
  },
  registerButtonsWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  registerButtonsWrapperMobile: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  registerButtonsMobile: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  registerButton: {
    marginRight: theme.spacing(1),
  },
  version: {
    position: "fixed",
    bottom: 6,
    right: 6,
    color: "#fff",
    opacity: "0.3",
  },
})

export default styles
